import React from "react";
import { Alert } from "antd";
import { Link } from "react-router-dom";

interface PropertyAdminAlertProps {
  isRenewal: boolean;
  propertyId?: string;
  adminName?: string;
  style?: React.CSSProperties;
}

const PropertyAdminAlert: React.FC<PropertyAdminAlertProps> = ({ isRenewal, propertyId, adminName, style }) => {
  if (!isRenewal || !propertyId || adminName) return null;

  return (
    <Alert
      type="error"
      message="Property admin is not set for this property."
      description={
        <>
          Please set a property admin so this renewal can be managed correctly.{" "}
          <Link to={`/property-detail/${propertyId}`} target="_blank" rel="noopener noreferrer">
            Go to property details to edit
          </Link>
        </>
      }
      style={{ width: "65%", marginLeft: "25px", ...style }}
    />
  );
};

export default PropertyAdminAlert;
